module.exports = __webpack_public_path__ + "static/media/Template_4.1d38b9e6.png";